import React from 'react';
import classNames from 'classnames';

import css from './VerifiedBadge.module.css';

/**
 * VerifiedBadge — pill horizontal con hexágono Caribbean Green +
 * texto "VERIFICADO".
 *
 * @param {Object} props
 * @param {'sm'|'md'|'lg'} [props.size='md'] - Tamaño de la pill
 * @param {string} [props.className] - Override puntual
 * @param {boolean} [props.iconOnlyMobile=false] - En móvil (<640px) oculta
 *   el texto "VERIFICADO" y deja solo el sello (icono circular). A partir
 *   de 640px recupera el pill completo con texto. Solo lo usa la card de
 *   listing; el resto de usos mantienen el pill con texto en todos los anchos.
 * @returns {JSX.Element}
 */
const SIZES = {
  sm: { icon: 12, pillCls: 'pillSm', textCls: 'textSm' },
  md: { icon: 14, pillCls: 'pillMd', textCls: 'textMd' },
  lg: { icon: 16, pillCls: 'pillLg', textCls: 'textLg' },
};

// OCULTAR-VERIFICACION: interruptor único para el sello. Los cuatro puntos de
// render (UroboroxListingCard, ListingSummaryCard, ListingPageCarousel,
// ListingCard) quedan intactos: para revertir basta con poner esto a true.
const SHOW_VERIFIED_BADGE = false;

const VerifiedBadge = ({ size = 'md', className, iconOnlyMobile = false }) => {
  if (!SHOW_VERIFIED_BADGE) {
    return null;
  }

  // Acepta tamaños 'sm'/'md'/'lg'. Cualquier otro valor (incluido el
  // legacy numérico size={20} del template Sharetribe) cae al
  // default 'md' sin romper.
  const cfg = SIZES[size] || SIZES.md;

  return (
    <span
      className={classNames(
        css.pill,
        css[cfg.pillCls],
        { [css.iconOnlyMobile]: iconOnlyMobile },
        className
      )}
      aria-label="Negocio verificado"
      role="img"
    >
      <svg
        width={cfg.icon}
        height={cfg.icon}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* Literales Tailwind (green-400 / emerald-950) en lugar de var():
            los atributos fill/stroke de SVG no resuelven custom properties
            cuando se interpretan como atributos HTML. */}
        <polygon points="12,2 21,7 21,17 12,22 3,17 3,7" fill="#4ADE80" />
        <polyline
          points="8 12 11 15 16 9"
          stroke="#022C22"
          strokeWidth="2.8"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span
        className={classNames(css.text, css[cfg.textCls], {
          [css.textCollapseMobile]: iconOnlyMobile,
        })}
      >
        VERIFICADO
      </span>
    </span>
  );
};

export default VerifiedBadge;
